var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
var AuthCustomerServiceComponent = /** @class */ (function (_super) {
    __extends(AuthCustomerServiceComponent, _super);
    function AuthCustomerServiceComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.data = {};
        return _this;
    }
    AuthCustomerServiceComponent.prototype.ngOnInit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2177' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2177 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        this.data = this.modalService.data;
        sessionStorage.setItem("currentWindow", "שירות לקוחות");
        sessionStorage.setItem("elasticCode", "2194");
    };
    AuthCustomerServiceComponent.prototype.submit = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid) {
            this.pending = true;
            var comeFrom = sessionStorage.getItem("comeFrom");
            //console.log("sent parametes", { CustomerServiceFromScreenId: comeFrom, firstName: form.value.firstName, lastName: form.value.lastName });
            this.authUserService.sendAuthData("CustomerHelp", { CustomerServiceFromScreenId: comeFrom, firstName: form.value.firstName, lastName: form.value.lastName })
                .subscribe(function (res) {
                _this.modalService.close(res.Details);
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    return AuthCustomerServiceComponent;
}(AuthBaseComponent));
export { AuthCustomerServiceComponent };
